var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.noMoreMatchNotif = function() {
    var _this = this;
    EHDI.aka.Container.call(this);
    
    var overlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0x000000, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
    this.addChild(overlay);
    overlay.interactive = true;
    overlay.alpha = 0.5;
    
    var sprite = new EHDI.aka.Sprite(EHDI.Assets.images["cm_ui_matchpopup"]);
    sprite.anchor.set(0.5);
    sprite.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.5);
    this.addChild(sprite);
    
    var text = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_NOMOREMATCHES"));
    text.anchor.set(0.5);
    sprite.addChild(text);
    
    var cakeShuffled = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_CAKESHUFFLED"));
    cakeShuffled.anchor.set(0.5);
    sprite.addChild(cakeShuffled);
    cakeShuffled.alpha = 0;
    
    var timeline = new TimelineMax();
    
    timeline.from(sprite.scale, 0.5, {x : 0, y : 0, ease : Bounce.easeOut});
    timeline.from(text, 0.25, {alpha : 0});
    timeline.to(text, 0.25, {alpha : 0}, "+=0.75");
    timeline.to(cakeShuffled, 0.25, {alpha : 1});
    timeline.to(this, 0.5, {alpha : 0}, "+=0.75");
    timeline.addCallback(function() {
        EHDI.GAME.pauseButton.isPaused = false;
        _this.destroy({children : true});
        _this = null;
    });
}

EHDI.components.noMoreMatchNotif.prototype = Object.create(EHDI.aka.Container.prototype);